import { render, staticRenderFns } from "./provideCommunityInfoSecond.vue?vue&type=template&id=a3faf498&scoped=true&"
import script from "./provideCommunityInfoSecond.vue?vue&type=script&lang=js&"
export * from "./provideCommunityInfoSecond.vue?vue&type=script&lang=js&"
import style0 from "./provideCommunityInfoSecond.vue?vue&type=style&index=0&id=a3faf498&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3faf498",
  null
  
)

export default component.exports